export default "__VITE_ASSET__CBWs2iW$__"